import axios from 'axios';

const API = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && localStorage.getItem('user') && !error.config?.url?.endsWith('/auth/login')) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      sessionStorage.setItem('session-notice', 'Sesiunea a expirat sau a fost revocată. Autentifică-te din nou.');
      window.dispatchEvent(new Event('session-revoked'));
    }
    return Promise.reject(error);
  }
);

export default API;

export const apiError = (error) => {
  const detail = error.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map(d => d.msg).join('; ');
  return 'Operațiunea nu a reușit. Reîncearcă.';
};
